<template>
  <div class="inside-event">
    <el-row style="margin-top: 30px">
      <el-container class="info-box">
        <el-header class="info-box-header" style="border-bottom: none">
          <el-col :span="16">
            <span class="info-box-title">已订阅的事件</span>
          </el-col>
          <el-col :span="8">
            <el-button v-if="!onlyReadState.includes(ruleForm.appState)" class="info-box-btn" size="medium" type="primary" @click="addEvent">添加事件订阅 </el-button>
          </el-col>
        </el-header>
        <el-main style="padding: 0">
          <new-table :data="eventSubscribeList" :columns="eventColumns" :pages="false"></new-table>
        </el-main>
      </el-container>
    </el-row>
    <el-dialog class="abow_dialog" title="添加事件订阅" :visible.sync="eventDialogVisible" destroy-on-close width="700px">
      <el-container class="container">
        <el-aside width="47%" class="aside">
          <div class="header">可添加：</div>
          <div class="tree-container">
            <el-tree class="tree" node-key="id" default-expand-all :props="props" :data="eventData">
              <div class="custom-tree-node" slot-scope="{ data }" :title="data.eventName">
                <div class="md-ellipsis" style="width: 90%; display: inline-block">
                  {{ data.eventName }}
                </div>
                <el-button style="float: right" type="text" v-if="!data.isCheck && !data.eventTypeList" @click.stop="eventCheck(data)">
                  <i class="el-icon-circle-plus-outline" style="font-size: 16px"></i>
                </el-button>
              </div>
            </el-tree>
          </div>
        </el-aside>
        <el-main style="padding: 0 !important; margin-left: 25px">
          <div class="header">已添加：</div>
          <div class="tree-container">
            <el-tree class="tree" node-key="id" default-expand-all :props="props" :data="eventCheckGroup">
              <div class="custom-tree-node" slot-scope="{ data }" :title="data.eventName">
                <div class="md-ellipsis" style="width: 90%; display: inline-block" :class="{ disabled: data.isEnabled === 0 }">
                  {{ data.isEnabled === 0 ? "（已禁用）" + data.eventName : data.eventName }}
                </div>
                <el-button style="float: right" v-if="!data.eventTypeList" type="text" @click.stop="eventUnCheck(data)">
                  <i class="el-icon-remove-outline color-red" style="font-size: 16px"></i>
                </el-button>
              </div>
            </el-tree>
          </div>
        </el-main>
      </el-container>
      <div slot="footer" class="dialog-footer">
        <el-button @click="eventDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEventAuth()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { InsideService } from "@/apis/insede";
import { GroupType, IsStart } from "@/service/enum";
import NewTable from "@/components/new-table.vue";

export default {
  name: "inside-event",
  props: {
    ruleForm: Object,
  },
  data() {
    return {
      onlyReadState: [1, 2, 6], //不能进行修改的app状态
      eventCheckGroup: [],
      eventColumns: [
        { label: "事件名称", prop: "eventTypeName" },
        { label: "事件类型", prop: "eventType" },
        { label: "描述", prop: "remark" },
        {
          label: "操作",

          width: "100",
          render: (h, { row }) => {
            return (
              <div>
                <el-button
                  type="text"
                  size="small"
                  disabled={row.default || this.onlyReadState.includes(this.ruleForm.appState)}
                  onClick={() => {
                    this.removeEventAuth(row);
                  }}
                >
                  移除
                </el-button>
              </div>
            );
          },
        },
      ],
      applicationId: 0,
      props: {
        children: "eventTypeList",
        label: "eventName",
      },
      eventType: "",
      page: 1,
      pageSize: 20,
      eventSubscribeList: [],
      eventData: [],
      callBackUrl: "www.baidu.com/api/xxx", // 回调的地址
      eventDialogVisible: false,
    };
  },
  created() {
    this.applicationId = this.$route.query.id;
    this.getEventSubscribe(); // 事件订阅的列表
  },
  methods: {
    // 删除订阅事件
    removeEventAuth(row) {
      this.$confirm("该订阅事件将被移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await InsideService.deleteEventSubscribe(row.id);
          this.$message.success("移除成功");
          this.getEventSubscribe();
        })
        .catch(() => {
          this.$message.info("已取消移除");
        });
    },
    //添加事件订阅
    addEvent() {
      this.eventDialogVisible = true;
      this.getAllEventGroupTree(); // 全部的
    },
    eventCheck(data) {
      const group = this.eventCheckGroup.find((e) => e.group === data.eventGroup);
      if (group) {
        group.eventTypeList.push(data);
      } else {
        const newGroup = { id: data.id, eventName: GroupType[data.eventGroup], group: data.eventGroup, eventTypeList: [data] };
        this.eventCheckGroup.push(newGroup);
      }
      data.isCheck = true;
    },
    eventUnCheck(data) {
      const gIndex = this.eventCheckGroup.findIndex((e) => e.group === data.eventGroup);
      const group = this.eventCheckGroup[gIndex];
      const delIndex = group.eventTypeList.findIndex((e) => e.id === data.id);
      group.eventTypeList.splice(delIndex, 1);
      if (group.eventTypeList.length === 0) {
        this.eventCheckGroup.splice(gIndex, 1);
      }
      if (data.isEnabled !== 0) {
        const eGroup = this.eventData.find((e) => e.group === data.eventGroup);
        const event = eGroup.eventTypeList.find((e) => e.id === data.id);
        event.isCheck = false;
      }
    },
    // 获取全部的事件订阅树
    async getAllEventGroupTree() {
      const res = await InsideService.getEventTypeGroupList();
      if (!res) return;
      this.eventData = res.map((item) => {
        item.eventName = GroupType[item.group];
        item.eventTypeList.forEach((i) => {
          i.isCheck = true;
        });
        return item;
      });
      this.getSubscribeGroupTree(); // 已选择的
    },
    // 获取已选择的应用事件订阅
    async getSubscribeGroupTree() {
      const res = await InsideService.getSubscribeGroup(this.applicationId);
      this.eventCheckGroup = res.map((item) => {
        return {
          group: item.eventGroup,
          eventName: GroupType[item.eventGroup],
          eventTypeList: item.eventCompSubscribeList.map((i) => {
            return {
              id: i.eventTypeId, // 跟左侧全部事件的id一致
              eventGroup: i.eventGroup,
              eventName: i.eventTypeName,
              eventType: i.eventType,
              isEnabled: i.isEnabled,
              isCheck: true,
            };
          }),
        };
      });

      let eventList = [];
      this.eventData.forEach((item) => {
        eventList.push(...item.eventTypeList);
      });
      let list = [];
      this.eventCheckGroup.forEach((item) => {
        list.push(...item.eventTypeList);
      });
      eventList.forEach((i) => {
        let findObj = list.find((f) => f.eventType === i.eventType);
        if (!findObj) i.isCheck = false;
      });
    },
    // 保存事件订阅
    async submitEventAuth() {
      let typeList = [];
      this.eventCheckGroup.forEach((item) => {
        typeList.push(
          ...item.eventTypeList.map((i) => {
            return {
              eventTypeId: i.id,
              eventTypeName: i.eventName,
              eventGroup: i.eventGroup,
              eventType: i.eventType,
            };
          })
        );
      });

      await InsideService.addEventSubscribe({ applicationId: this.applicationId, callBackUrl: this.callBackUrl, eventTypeList: typeList });
      this.eventDialogVisible = false;
      this.getSubscribeGroupTree(); // 已选择的
      this.getEventSubscribe(); //列表
    },
    // 获取事件订阅列表
    async getEventSubscribe() {
      const res = await InsideService.getEventSubscribeList(this.applicationId, this.eventType, this.page, this.pageSize);
      this.eventSubscribeList = res.data;
    },
  },
  components: { NewTable },
};
</script>
<style scoped lang="scss">
.disabled {
  color: #bfbfbf;
}
.custom-tree-node {
  height: 30px;
  line-height: 30px;
  flex: 1;
}
.container {
  height: 480px;
  border: none;

  .aside {
    .tree-container {
      border: 1px solid #d7d7d7;
      border-radius: 12px;
      overflow: hidden;

      .el-tree {
        border-radius: 12px;
        height: 400px;
        overflow: auto;
        padding: 10px;
      }
    }
  }

  .header {
    height: 40px;
    background: #f1f1f1ff;
    line-height: 40px;
    color: #333333ff;
    font-size: 16px;
    border-radius: 5px;
    padding-left: 10px;
    margin-bottom: 15px;
  }

  .el-main {
    .tree-container {
      border: 1px solid #d7d7d7;
      border-radius: 12px;
      overflow: hidden;

      .el-tree {
        border-radius: 12px;
        height: 400px;
        overflow: auto;
        padding: 10px;
      }
    }
  }
}
.info-box {
  width: 936px;
  border: 1px solid #cdcdcd;
  border-radius: 6px;

  .info-box-header {
    height: 72px !important;
    border-bottom: 1px solid #cdcdcd;

    .info-box-title {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #666666;
      line-height: 72px;
    }

    .info-box-btn {
      float: right;
      margin-top: 18px;
      width: 130px;
    }

    .btn-small {
      margin-right: 8px;
      width: 80px;
    }
  }

  .info-box-aside {
    width: 133px !important;
    text-align: center;
    border-right: 1px solid #cdcdcd;
    padding-top: 14px;

    .avatar {
      height: 62px;
      width: 62px;
      border-radius: 15px;
    }

    .el-upload__tip {
      font-size: 11px;
      color: #999999;
      line-height: 15px;
    }

    .info-box-proof {
      height: 45px !important;
      padding: 0;
      color: #666666ff;
      font-size: 14px;
      line-height: 45px;
      width: 100%;
    }
  }

  .info-box-content {
    padding: 0 20px !important;
    border-bottom: 1px solid #cdcdcd;

    .appName-row {
      ::v-deep .el-form-item__error {
        margin-left: 524px;
        margin-top: -46px;
      }
    }

    .info-box-input {
      margin-top: 8px;
      width: 514px;
    }

    .tip {
      font-size: 11px;
      color: #999999;
    }
  }

  .info-box-footer {
    height: 45px;

    .info-box-textarea {
      margin-top: 12px;

      ::v-deep textarea {
        max-height: 100px;
      }
    }
  }

  .info-box-label {
    font-family: PingFangSC-Regular, PingFang SC;
    color: #333333ff;
    font-size: 14px;
    line-height: 45px;
  }
}
</style>
